export const changeCurrentStep = (stepId) => {
  return {
    type: 'CHANGE_STEP',
    stepId
  }
}



// WEBPACK FOOTER //
// ./src/actions/processStep.actions.js